import content from '../content.json';

// Simple monochrome SVG icons — gray 20%
const icons = {
  parking: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="30" height="30" rx="2" stroke="#333" strokeWidth="1.5"/>
      <path d="M11 22V10h6a4 4 0 010 8h-6" stroke="#333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  wifi: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12a17 17 0 0124 0" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 17a11 11 0 0116 0" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 22a5 5 0 018 0" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="16" cy="26" r="1.5" fill="#333"/>
    </svg>
  ),
  breakfast: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 10h16v12a4 4 0 01-4 4H12a4 4 0 01-4-4V10z" stroke="#333" strokeWidth="1.5"/>
      <path d="M24 13h2a2 2 0 010 4h-2" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 6v4M16 5v5M22 6v4" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  court: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 4v6M16 22v6M7 16H4M28 16h-3" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="16" cy="16" r="6" stroke="#333" strokeWidth="1.5"/>
      <path d="M10.5 10.5l3.5 3.5M21.5 21.5l-3.5-3.5M21.5 10.5l-3.5 3.5M10.5 21.5l3.5-3.5" stroke="#333" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    </svg>
  ),
};

export default function Amenities() {
  return (
    <section style={{ background: '#ffffff', padding: '80px 0', borderTop: '1px solid #ece8e0', borderBottom: '1px solid #ece8e0' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '56px' }}>
          <span className="section-label">Elevate your stay with our features</span>
          <h2 className="section-title">Unveiling Our Signature Amenities</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '0' }}>
          {content.amenities.map((item, i) => (
            <div key={i} className="reveal" style={{ transitionDelay: `${i*0.1}s`, padding: '40px 32px', borderRight: i<3?'1px solid #ece8e0':'none', display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'flex-start' }}>
              <div style={{ flexShrink: 0, marginTop: '2px', opacity: 0.6 }}>{icons[item.icon]}</div>
              <div>
                <h4 style={{ fontFamily:'var(--font-body)',fontSize:'12px',fontWeight:700,letterSpacing:'0.05em',color:'var(--text)',marginBottom:'8px',textTransform:'uppercase' }}>{item.title}</h4>
                <p style={{ fontFamily:'var(--font-body)',fontSize:'12px',color:'var(--text2)',lineHeight:1.6 }}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
